import React from 'react';
import Header from './Header';
import Footer from './Footer';

const SyrupsAndSuspensions = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .accordion-item {
                border: 1px solid rgba(0,0,0,.125);
                margin-bottom: 1rem;
                border-radius: 0.5rem !important;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0,0,0,.05);
                transition: all 0.3s ease;
            }
            .accordion-item:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,.1);
                transform: translateY(-2px);
            }
            .accordion-button {
                padding: 1.25rem;
                font-weight: 600;
                font-size: 1.1rem;
                color: #333;
                background-color: #f8f9fa;
                border: none;
                position: relative;
            }
            .accordion-button:not(.collapsed) {
                color: #fff;
                background-color: var(--cnvs-themecolor, #2E3192);
                box-shadow: none;
            }
            .accordion-button:not(.collapsed)::after {
                filter: brightness(0) invert(1);
            }
            .accordion-button:focus {
                box-shadow: none;
                border-color: rgba(0,0,0,.125);
            }
            .accordion-body {
                padding: 1.5rem;
                background-color: #fff;
            }
            .table {
                margin-bottom: 0;
            }
            .table thead th {
                background-color: #f8f9fa;
                border-bottom: 2px solid #dee2e6;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.85rem;
                letter-spacing: 0.5px;
            }
            .table tbody td {
                vertical-align: middle;
                font-size: 0.95rem;
            }
            .table tbody tr:hover {
                background-color: rgba(0,0,0,.02);
            }
        </style>

        <div id="wrapper">
            <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                <div class="container mt-lg-6">
                    <div class="row justify-content-between align-items-center py-lg-6 py-5">
                        <div class="col-lg-5 mb-4 mb-lg-0">
                            <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                            <h2 class="display-3 fw-bold color all-ts">Syrups and <span class="underliner nocolor viewport-detect" data-delay="1000">Suspensions</span></h2>
                            <p>Explore our range of syrups and suspensions for various health needs</p>
                        </div>
                        <div class="col-lg-6">
                            <div class="row align-items-center g-4">
                                <div class="col-6">
                                    <img src="https://i.pinimg.com/736x/2a/0a/0c/2a0a0c1e9f2df4591d14645aa2b39a28.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                                <div class="col-6">
                                    <img src="demos/doctors/images/hero/r2.jpg" alt="Image" class="object-cover rounded-6 mb-4">
                                    <img src="demos/doctors/images/hero/r3.jpg" alt="Image" class="object-cover rounded-6">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="content">
                <div class="content-wrap py-0">
                    <div id="products" class="section bg-transparent">
                        <div class="container">
                            <div class="row justify-content-center mb-4">
                                <div class="col-md-9 text-center">
                                    <h2 class="display-4 mb-3">Syrups and Suspensions</h2>
                                    <p>Comprehensive range of syrups and suspensions for optimal health and wellness</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="accordion">
                                        <!-- VITAMIN & MINERAL SYRUPS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#vitaminSyrups">
                                                    <i class="bi bi-capsule me-2"></i>VITAMIN & MINERAL SYRUPS
                                                </button>
                                            </h2>
                                            <div id="vitaminSyrups" class="accordion-collapse collapse show">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>COMPOSITION</th>
                                                                    <th>PACKING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>1</td><td>Blueberry 20 Mg+ascorbic Acid 50mg+selenium 35 Mcg + Zinc 3mg+copper 500 Mcg+thiamine 2mg+riboflavin 3mg+pyridoxine</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>2</td><td>Vitamin A 2500 Iu + Cholrcalciferol 100 Iu +Vitamin E 25 Iu + Thiamine Hydrochloride 0.75mg+ Riboflavin Sodium Phosphate Eq. to Riboflavin 0.75mg + Pyidoxine Hydrochloride 0.5 Mg + Cyanocobalamin 0.5 Mg +Nicotinamide 7.5 Mg + D-panthenol 2.5 Mg + Zinc Sulphate 22.2 Mg + Potassium Iodide 50 Mcg + Copper Sulphate 100 Mcg + Lysine Hydrochloride 5 Mg Each 5 Ml</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>3</td><td>B-complex With L-lysine Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>4</td><td>B-complex With Multivitamin And Zinc Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>5</td><td>Antioxidants, Vitamins & Minerals Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>6</td><td>Omega 3 600mg + Dha 300mg + Epa 150mg+Vitamin A 400 Iu + Vitamin D 200 Iu + Vitamin E 3mcg + Vitamin C 50Mg Bottle</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>7</td><td>Essential Vitamins & Minerals Ferrous Bisglycinate Equivalent To Elemental Iron 10 Mg + Zinc Bis Glycinate Equivalent To Elemental Zinc 2.5 Mg + Folic Acid 0.5 Mg + Vitamin B12 1 Mcg Each 1 Ml Drop</td><td>30ML DROP</td></tr>
                                                                <tr><td>8</td><td>Zinc Gluconate 20mg Each 1ml Drop</td><td>30ML DROP</td></tr>
                                                                <tr><td>9</td><td>Lycopene With Antioxidants,vitamins And Minerals Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>10</td><td>Cholecaiciferol 200iu + Pyridoxine Hydrochioride 1 Mg + Niacinamide 15mg + Cyanocobalamin 1mcg + Zinc 3 Mg + B- Carotene Dispersion 38 Mg + Manganese 0.8mg + Molybdenum 8mcg + Selenium 10 Mcg + Lysine Hydrochioride 30mg+ Iodine 50 Mcg + Biotin 10 Mcg + Chromium 10 Mcg + Inositol 10 Mg</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>11</td><td>Zinc 5mg + Vitamin A 1250 Iu + Lycopene 2000 Mcg + Folic Acid 1.5 Mg + Vitamin B6 1.5 Mg + Vitamin B2 1.3 Mg + Vitamin B1 1.1 Mg+Manganese 0.8 Mg + Mecobalamin 500 Mcg + Iodine 90 Mcg + Chromium 70mcg Each 5 Ml</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>12</td><td>Lycopene 5000 Mcg+vit.a 2500 I.u.+vit.e 10i.u.+vit.c.50mg+ Selenium 35mcg+ zinc3mg+manganese 2mg+ Iodine 100mcg+copper 500 Mcg+thiamine 2mg +riboflavine 3mg +pyridoxine 1.5mg (choclate Flavoured Base)</td><td>200 ml/100ml</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CALCIUM & IRON SYRUPS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#calciumIronSyrups">
                                                    <i class="bi bi-capsule me-2"></i>CALCIUM & IRON SYRUPS
                                                </button>
                                            </h2>
                                            <div id="calciumIronSyrups" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>COMPOSITION</th>
                                                                    <th>PACKING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>1</td><td>Calcium Citrate, Magnesium, Zinc & Vitamin D3 Suspension</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>2</td><td>Ferrous Ascorbate & Folic Acid Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>3</td><td>Ferric Ammonium Citrate With Folic Acid & Zinc Syrup</td><td>200 ml/100ml</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- LIVER & DIGESTIVE SYRUPS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#liverDigestiveSyrups">
                                                    <i class="bi bi-capsule me-2"></i>LIVER & DIGESTIVE SYRUPS
                                                </button>
                                            </h2>
                                            <div id="liverDigestiveSyrups" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>COMPOSITION</th>
                                                                    <th>PACKING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>1</td><td>Silymarin With B.complex Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>2</td><td>L-ornithine-l-aspartate,tricholine, Silymarin With B.complex Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>3</td><td>Silymarin With Calcium Pangamate & B-complex Suspension</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>4</td><td>Silymarin With Vitamins And Cyanocobalamin Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>5</td><td>Fungal Diastase With Pepsin Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>6</td><td>Alpha-amylase – 20 Mg + Papain-10 Mg + Dill Oil. -2 G + Anise Oil-2 Mg + Caraway Oil – 2 Mg</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>7</td><td>Enzyme Formula Syrup /drops</td><td>200 ml/100ml</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- HERBAL & SPECIALTY SYRUPS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#herbalSyrups">
                                                    <i class="bi bi-capsule me-2"></i>HERBAL & SPECIALTY SYRUPS
                                                </button>
                                            </h2>
                                            <div id="herbalSyrups" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>COMPOSITION</th>
                                                                    <th>PACKING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>1</td><td>Carica Papaya Leaf 420 Mg + Pomegranate Fruit 200 Mg + Kivi Fruit + 200mg + Tinospora Cordifolia 180 Mg + Ocimum Tenuifluorun 100 Mg + Phyllanthus Emblica 100 Mg Each 5 Ml</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>2</td><td>Royal Jelly 50 Mg+ascorbic Acid 50mg+selenium 35 Mcg+ Zinc 3mg+ copper 500 Mcg+thiamine 2mg+riboflavine 3mg+pyrido</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>3</td><td>Protein Tonic With Iron,vitamins And Minerals</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>4</td><td>Coenzyme Q 10 100 Mg +lycopene (8% ) 10000mcg +green Tea Extract 200 Mg + Grape Seed Extract 25 Mg + B1 10 Mg + B2 10 Mg + B6 2 Mg + E 12.5 Mg</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>5</td><td>L-lysine – 50 Mg + Nicotinamide -15 Mg + D- Panthenol- 3 Mg + Riboflavin Sodium Phosphate -2.5 Mg + Thiamine Hcl -2 Mg + Pyridoxine Hcl – 0.75 Mg + Cyanocobalamin – 2 Mcg Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>6</td><td>Multivitamin, Minerals And Antioxidants Syrup</td><td>200 ml/100ml</td></tr>
                                                                <tr><td>7</td><td>Cyanocobalamin With Lycopene And Multivitamin Syrup</td><td>200 ml/100ml</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- PROBIOTIC & ZINC SYRUPS -->
                                        <div class="accordion-item">
                                            <h2 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#probioticSyrups">
                                                    <i class="bi bi-capsule me-2"></i>PROBIOTIC & ZINC SYRUPS
                                                </button>
                                            </h2>
                                            <div id="probioticSyrups" class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>S.NO</th>
                                                                    <th>COMPOSITION</th>
                                                                    <th>PACKING</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr><td>1</td><td>Zinc Gluconate With Prebiotics & Probiotics Oral Suspension (dry Syrup)</td><td>60 ml</td></tr>
                                                                <tr><td>2</td><td>Zinc Gluconate Solution</td><td>60 ml</td></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default SyrupsAndSuspensions; 